export const imgArtallBg = require("./media/background/artall.jpg");
export const imgFoBg = require("./media/background/fo.jpg");
export const imgReBg = require("./media/background/re.jpg");
export const imgThinktankBg = require("./media/background/thinktank.jpg");
export const imgVclubBg = require("./media/background/vclub.jpg");
export const imgCambridgeBg = require("./media/background/cambridge.jpg");
export const imgTechBg = require("./media/background/tech.jpg");
export const videoHomeBg = require("./media/background/london.mp4");
export const videoHomeBgPoster = require("./media/background/london-poster.jpg");
export const imgAboutBg = require("./media/background/mayfair.jpg");
export const imgJudgeBusinessSchool = require("./media/background/cambridge-judge-business-school.jpg");
export const imgOurFirmBg = require("./media/background/team.jpg");
export const imgOffice = require("./media/background/office.jpg");
export const imgReMap = require("./media/background/reMap.jpg");
export const imgArtallLogos = require("./media/logo/artall-logos.png");
export const imgThinktankArticles = require("./media/background/thinkTankArticles.jpg");
export const imgVclubEvents = require("./media/background/vclubEvents.jpg");

// logos
export const logoCambridge = require("./media/logo/cambridge-logo.png");
export const logoCambridgeHorizontal = require("./media/logo/cjbs.png");
export const logoOxford = require("./media/logo/oxford-logo.png");
export const logoICL = require("./media/logo/icl-logo.png");

export const logoArla = require("./media/logo/arla.jpg");
export const logoCmp = require("./media/logo/cmp.png");
export const logoDps = require("./media/logo/dps.png");
export const logoPrs = require("./media/logo/prs.png");
export const logoNrla = require("./media/logo/nrla.png");
export const logoCiol = require("./media/logo/ciol.png");
export const logoAckroyd = require("./media/logo/ackroyd-logo.png");
export const logoBarclays = require("./media/logo/barclays-logo.png");
export const logoBlick = require("./media/logo/blick-logo.png");
export const logoBurlingtons = require("./media/logo/burlingtons-logo.png");
export const logoCiti = require("./media/logo/citi-logo.png");
export const logoDamac = require("./media/logo/damac-logo.png");
export const logoDeloitte = require("./media/logo/deloitte-logo.png");
export const logoEfg = require("./media/logo/efg-logo.png");
export const logoEmaar = require("./media/logo/emaar-logo.png");
export const logoEy = require("./media/logo/ey-logo.png");
export const logoIaa = require("./media/logo/iaa-logo.png");
export const logoKpmg = require("./media/logo/kpmg-logo.png");
export const logoPwc = require("./media/logo/pwc-logo.png");
export const logoSpencerWest = require("./media/logo/spencer-west-logo.png");
export const logoStep = require("./media/logo/step-logo.png");
export const logoUbs = require("./media/logo/ubs-logo.png");
export const logoUob = require("./media/logo/uob-logo.png");

export const logoNVIG = require("./media/company/nvig-logo-horizontal.png");
export const logoNVIGDark = require("./media/company/nvig-logo-dark.png");
export const logoNVIGOnly = require("./media/company/nvig-logo.png");

export const qrChat = require("./media/company/qr-chat.png");
export const qrFollow = require("./media/company/qr-follow.png");

export const conference0 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-0.jpeg");
export const conference1 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-1.jpeg");
export const conference2 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-2.jpeg");
export const conference3 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-3.jpeg");
export const conference4 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-4.jpeg");
export const conference5 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-5.jpeg");
export const conference6 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-6.jpeg");
export const conference7 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-7.jpeg");
export const conference8 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-8.jpeg");
export const conference9 = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-9.jpeg");
export const conferenceSpeakers = require("./media/insights/STEP Alpine Conference 2026/step-alpine-conference-2026-speakers.jpeg");
